<template>
	<form @submit.prevent="block">
		<ManagingSection class="batch-block">
			<ManagingBox title="대상ID">
				{{ params.ids.join(', ') }}
			</ManagingBox>
			<ManagingBox
				title="사유"
				:horizontalMode="true"
				contsClass="batch-block__static-code-wrapper"
			>
				<Selector
					v-model="staticCode1"
					:optionList="staticCodes"
					valueKey="code"
				/>
				<Selector
					v-model="staticCode2"
					:optionList="staticCodes"
					valueKey="code"
				/>
				<p
					v-if="!staticCode1"
					class="batch-block__static-code-err"
					v-text="'첫번째 사유는 필수로 선택해야 합니다!'"
				/>
			</ManagingBox>

			<div class="btn-wrap-main">
				<button
					type="button"
					class="btn-main"
					v-text="'취소'"
					@click="$store.commit('modal/toggleModal', false)"
				/>
				<button
					:disabled="!staticCode1 && !staticCode2"
					type="submit"
					class="btn-main blue"
					v-text="'차단'"
				/>
			</div>
		</ManagingSection>
	</form>
</template>
<script>
	import compact from 'lodash/compact';
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import Selector from '@/components/Selector.vue';

	export default {
		name: 'QnaStateBatchBlock',
		components: {
			ManagingSection,
			ManagingBox,
			Selector,
		},
		data() {
			return {
				staticCode1: null,
				staticCode2: null,
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
				staticCodes: state =>
					state.filter.staticCodes.filter(
						item => item.parent_code === 'QNA_BLOCK'
					),
			}),
		},
		methods: {
			async block() {
				try {
					const params = {
						state: '차단',
						idList: this.params.ids,
						staticCodeList: compact([
							this.staticCode1,
							this.staticCode2,
						]).map(code => ({ code })),
					};
					const path =
						this.params.type === '질문'
							? '/api/qna/state'
							: '/api/qna/reply/state';
					await this.$axiosAdmin2.put(path, params);
					this.params.modalComplete();
				} catch (err) {
					console.error(err);
					alert('일괄차단에 실패했습니다.');
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.batch-block {
		&::v-deep .batch-block__static-code-wrapper {
			flex-wrap: wrap;
		}

		&__static-code-err {
			width: 100%;
			color: $red;
		}
	}
</style>
